<div class="snack" [ngClass]="snack.theme" (click)="click($event)">
  <ui-snackbar-templates
    *ngIf="!!snack.template; else textTemplate"
    [template]="snack.template"
  ></ui-snackbar-templates>

  <ng-template #textTemplate>
    <h4 *ngIf="snack.title">{{ snack.title }}</h4>

    <p *ngIf="snack.text">
      {{ snack.text }}
    </p>

    <p class="html-content" *ngIf="snack.html" processLinks [innerHtml]="snack.html | sdSafeHtml"></p>

    <button
      sdButton
      size="l"
      [type]="snack.theme === snackTheme.White ? 'primary' : 'inversion'"
      *ngIf="snack.button"
      (click)="onBtnClick()"
    >
      {{ snack.button.label }}
    </button>
  </ng-template>

  <button class="btn btn-link remove-btn" (click)="close()">
    <cx-icon class="remove-icon" [type]="iconType.CLOSE"></cx-icon>
  </button>
</div>
